import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL!;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export interface PropertyMarker {
  id: number;
  project_name: string;
  latitude: number;
  longitude: number;
  price_range: string;
  price_per_sqft: string;
  configurations: string;
  developer: string;
  location: string;
  micro_market?: string;
}

export async function fetchPropertyMarkers(): Promise<PropertyMarker[]> {
  const { data, error } = await supabase
    .from('properties')
    .select('id,project_name,latitude,longitude,price_range,price_per_sqft,configurations,developer,location,micro_market');
  if (error) {
    console.error('Supabase fetch error:', error);
    return [];
  }
  return data || [];
} 